export const Placeholders = {
  SelectLayerFromWorkspace: 'Select Layer from Workspace',
};
